import React from 'react';
import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Table from '../../../../Components/Table';
import { __, formatDate, FORMAT_HUMANE_DATETIME } from '../../../../Utils';
import FileViewDownload from '../../../../Components/FileViewDownload';
import API2 from '../../../../API2';

const MainWrapper = styled.div``;

const StyledHeader = styled.div`
  display: flex;
  margin-left: 4px;
  font-size: 12px;
  color: #434245;
  margin-top: 15px;
  cursor: default;
`;

const StyledTd = styled.div`
  // display: flex;
  margin-left: 10px;
  height: 15px;
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  color: '#434245';
  font-weight: 500;
`;

const StyledName = styled(StyledTd)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(300)};
`;

class Documentations extends React.Component {
  createColumns() {
    const result = [
      // {
      //   accessor: 'type',
      //   Header: () => <StyledHeader>{__('Typ')}</StyledHeader>,
      //   Cell: props => {
      //     return <StyledTd>{props.value}</StyledTd>;
      //   },
      // },
      {
        accessor: 'name',

        Header: () => <StyledHeader>{__('Názov')}</StyledHeader>,
        Cell: props => {
          return <StyledName title={props.value}>{props.value}</StyledName>;
        },
      },
      {
        accessor: 'langs',
        Header: () => <StyledHeader>{__('Jazyk')}</StyledHeader>,
        Cell: props => {
          return <StyledTd>{props.value.join(', ')}</StyledTd>;
        },
      },
      {
        accessor: 'file_updated_date',
        Header: () => (
          <StyledHeader>{__('Posledná aktualizácia')}</StyledHeader>
        ),
        Cell: props => {
          return (
            <StyledTd>
              {formatDate(moment(props.value), FORMAT_HUMANE_DATETIME)}
            </StyledTd>
          );
        },
      },
      {
        accessor: 'file',
        Header: () => <StyledHeader>{__('Zobraziť/Stiahnúť')}</StyledHeader>,
        Cell: props => {
          return (
            <StyledTd>
              <FileViewDownload
                name={props.value.name}
                type={props.value.mimeType}
                fullPath={props.value.fullPath}
                history={this.props.history}
                downloadFunction={async () => {
                  return API2.getB2BDocumentationDownloadAction(
                    props.original._id,
                  );
                }}
              />
            </StyledTd>
          );
        },
      },
    ];

    return result;
  }

  render() {
    const { data } = this.props;

    return (
      <MainWrapper>
        <Table
          columns={this.createColumns()}
          minWidth={10}
          loadingColor="#70af00"
          style={{
            border: 'unset',
          }}
          data={data}
          pageSize={data.length}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: () => {},
              };
            }
            return {};
          }}
          getTdProps={() => {
            return { style: { padding: 0, margin: 'auto', border: 0 } };
          }}
          getTheadThProps={(state, rowInfo, column) => {
            return {
              style: { border: 0 },
            };
          }}
          className="-highlight -striped"
          offset={120}
        />
      </MainWrapper>
    );
  }
}

Documentations.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  downloadFile: PropTypes.func,
  history: PropTypes.shape({}),
};

Documentations.defaultProps = {
  data: [],
  downloadFile: () => {},
  history: {},
};

export default Documentations;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/Documentations/index.jsx